<!-- <tt-button (ttClick)="getConsignmentLabelPdf()"></tt-button> -->
<tt-page *ngIf="!!get">
    <tt-page-heading *ngIf="!!get.page_heading">{{ get.page_heading }}</tt-page-heading>
    <tt-tabs ttRememberId="w_concern_orders_grid.tab" [(ttSelectedId)]="get.selected_tab" (ttSelectedIdChange)="readGrid()">
        <tt-tab ttId="create" ttLabel="od_create_consignments"></tt-tab>
        <tt-tab ttId="printed" ttLabel="od_printed_consignments"></tt-tab>
        <tt-tab ttId="previous" ttLabel="od_previous_consignments"></tt-tab>
    </tt-tabs>
    <tt-card class="col-md-3 col-xs-12 sp-0">
        <tt-select
            ttRememberId="w_concern_orders_grid.stockplace_id"
            ttLabel="stockplace_id"
            [(ttModel)]="get.stockplace_id"
            (ttModelChange)="readGrid()"
            [ttData]="stockplaces"
            ttDataId="stockplace_id"
            ttDataName="stockplace_name"
        ></tt-select>
        <tt-date *ngIf="get.selected_tab === 'previous'" ttRememberId="w_concern_orders_grid.date_fom" ttLabel="date_fom" [(ttModel)]="get.date_fom" (ttModelChange)="readGrid()"></tt-date>
    </tt-card>
    <tt-grid [hidden]="get.selected_tab !== 'create'" *ngIf="!!createGrid" class="flex-1" [(ttOptions)]="createGrid"></tt-grid>
    <tt-grid [hidden]="get.selected_tab !== 'printed'" *ngIf="!!printedGrid" class="flex-1" [(ttOptions)]="printedGrid"></tt-grid>
    <tt-grid [hidden]="get.selected_tab !== 'previous'" *ngIf="!!previousGrid" class="flex-1" [(ttOptions)]="previousGrid"></tt-grid>
</tt-page>
